import { ToastData } from './ToastData';
import { ToastStore } from './ToastStore';
import { ToastVariant } from './ToastVariant';

const DEFAULT_DURATION = 4000;

let idCounter = 0;
const nextId = () => {
  idCounter += 1;

  return `toast-${idCounter}`;
};

export type ToastOptions = Partial<
  Pick<ToastData, 'duration' | 'closeOnClick' | 'filled' | 'appearance' | 'className' | 'rootProps'>
> & {
  /** `stack` (по умолчанию) добавляет тост в очередь, `replace` закрывает все текущие тосты и показывает только этот. */
  mode?: 'stack' | 'replace';
};

const show = (variant: ToastVariant, children: ToastData['children'], options?: ToastOptions) => {
  const id = nextId();
  const item: ToastData = {
    id,
    variant,
    children,
    duration: options?.duration ?? DEFAULT_DURATION,
    closeOnClick: options?.closeOnClick ?? true,
    filled: options?.filled ?? false,
    appearance: options?.appearance,
    className: options?.className,
    rootProps: options?.rootProps,
  };

  if (options?.mode === 'replace') {
    ToastStore.replace(item);
  } else {
    ToastStore.add(item);
  }

  return id;
};

/** Императивный API для показа тостов — вызывается откуда угодно, без провайдера. */
export const toast = {
  /** Показать инфо-тост, возвращает id для `toast.dismiss`. */
  info: (children: ToastData['children'], options?: ToastOptions) => show(ToastVariant.INFO, children, options),
  /** Показать успешный тост, возвращает id для `toast.dismiss`. */
  success: (children: ToastData['children'], options?: ToastOptions) => show(ToastVariant.SUCCESS, children, options),
  /** Показать тост об ошибке, возвращает id для `toast.dismiss`. */
  error: (children: ToastData['children'], options?: ToastOptions) => show(ToastVariant.ERROR, children, options),
  /** Показать тост-предупреждение, возвращает id для `toast.dismiss`. */
  warning: (children: ToastData['children'], options?: ToastOptions) => show(ToastVariant.WARNING, children, options),
  /** Закрыть тост по id, полученному от `toast.info/success/error/warning`. */
  dismiss: (id: string) => ToastStore.remove(id),
};
